if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();

        // ✅ Sync thumbnails with whatever slide is active in the viewer on load
if (this.elements.thumbnails && this.elements.viewer) {
  // Find the currently active slide, or fall back to the first slide
  const currentSlide =
    this.elements.viewer.querySelector('[data-media-id].is-active') ||
    this.elements.viewer.querySelector('[data-media-id]');

  if (currentSlide) {
    const mediaId = currentSlide.getAttribute('data-media-id');
    const thumb = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);

    // Clear all, then mark only the matching one as active
    this.elements.thumbnails.querySelectorAll('button').forEach((btn) => btn.removeAttribute('aria-current'));
    if (thumb) {
      this.setActiveThumbnail(thumb);
    }
  }
}
}

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
  const isMobile = !this.mql.matches; // matches "(min-width: 750px)"

  const viewer = this.elements.viewer;
  const thumbs = this.elements.thumbnails;

  const activeMedia = viewer.querySelector(`[data-media-id="${mediaId}"]`);
  if (!activeMedia) return;

  // 1) Activate the correct slide
  viewer.querySelectorAll('[data-media-id]').forEach((el) => el.classList.remove('is-active'));
  activeMedia.classList.add('is-active');

  // 2) Reorder ONLY on desktop (prepending makes it "first" image)
  if (!isMobile && prepend) {
    activeMedia.parentElement.prepend(activeMedia);
    if (thumbs) {
      const activeThumb = thumbs.querySelector(`[data-target="${mediaId}"]`);
      if (activeThumb) activeThumb.parentElement.prepend(activeThumb);
    }
    if (viewer.slider) viewer.resetPages();
  }

  this.preventStickyHeader();

  // 3) Horizontal scroll: desktop = normal; mobile = smooth (no reordering)
  window.setTimeout(() => {
    if (isMobile) {
      activeMedia.parentElement.scrollTo({
        left: activeMedia.offsetLeft,
        behavior: 'smooth',
      });
    } else {
      activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
    }

    const rect = activeMedia.getBoundingClientRect();
    if (rect.top > -0.5) return;
    const top = rect.top + window.scrollY;
    // window.scrollTo({ top, behavior: 'smooth' });
  });

  this.playActiveMedia(activeMedia);

  // 4) Thumbnails: always clear then set single active
  if (!thumbs) return;
  thumbs.querySelectorAll('button').forEach((btn) => btn.removeAttribute('aria-current'));
  const activeThumb = thumbs.querySelector(`[data-target="${mediaId}"]`);
  if (activeThumb) activeThumb.querySelector('button').setAttribute('aria-current', 'true');
  this.announceLiveRegion(activeMedia, activeThumb?.dataset.mediaPosition || 1);
}

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
